import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import How from "./How";
import Steps from "./Steps";
import FAQ from "./FAQ";
import Feature from "./Feature";
import Footer from "./Footer";

const Home = () => {
  return (
    <>
      <Header />
      <Hero />
      <How />
      <Steps />
      <Feature />
      <FAQ />
      <Footer />
    </>
  );
};

export default Home;
